import { render, staticRenderFns } from "./EduSchool.vue?vue&type=template&id=e4304d8e&scoped=true&"
import script from "./EduSchool.vue?vue&type=script&lang=js&"
export * from "./EduSchool.vue?vue&type=script&lang=js&"
import style0 from "./EduSchool.vue?vue&type=style&index=0&id=e4304d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4304d8e",
  null
  
)

export default component.exports